import React from 'react';
import BaseEntityList from './BaseEntityList';
import { EntityDesc } from './BaseAddEntityPopup/BaseAddEntityPopup';
import Terra from 'services/apis/terra/Terra';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { Platform } from 'data/terra/Platform';
import { fetchPlatforms } from 'containers/store/common/actions/FetchPlatforms';

function ListPlatform() {
  const dispatch = useDispatch();
  const { platforms } = useSelector((state: RootState) => state.common);

  return (
    <BaseEntityList<Platform>
      entityName="Platform"
      entities={platforms}
      itemsPerRow={6}
      onEntitySelected={() => {}}
      onSaveEntity={async (desc: EntityDesc) => {
        return Terra.platform.addPlatform(desc);
      }}
      onSaveEntityResult={result => {
        if (result.isSuccess()) {
          dispatch(fetchPlatforms());
        }
      }}
    />
  );
}

export default ListPlatform;
